import { Box, Container } from "@mui/material";
import Header from "./header";
import { Outlet } from "react-router-dom";
import FloatingActionButton from "../components/FloatingActionButton";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

const Layout = () => {
  // Wait for Kinde auth to initialize
  const { isLoading } = useKindeAuth();

  // Sync user profile to Supabase on auth
  // useProfileSync();

  if (isLoading) {
    return <div>Loading authentication...</div>;
  }

  return (
    <Box>
      <Header />
      <Container maxWidth="lg">
        <Outlet />
      </Container>
      <FloatingActionButton />
    </Box>
  );
};

export default Layout;
